import { FormInitializerReturnType } from 'src/Configuration/validation'
import { DefaultE3dcModel } from '../../models/wallbox-configuration/wallbox-configuration-settings-form.model'
import { WallboxConfigurationModel, WallboxPhaseType } from '../..'
import { object } from 'yup'
import useWallboxSettingsFormValidationFields from '../use-wallbox-settings-form-field-validations'

const ALLOWED_NUMBER_PHASES: WallboxPhaseType[] = [1, 3]

/**
 * Initializes the form for editing wallbox default settings
 * @param model WallboxConfigurationModel
 * @returns initialValues and validationSchema for wallbox default settings form
 */
export const useWallboxDefaultE3dcFormInitializer = (
  model?: WallboxConfigurationModel
): FormInitializerReturnType<DefaultE3dcModel, DefaultE3dcModel> => {
  const validationFields = useWallboxSettingsFormValidationFields()

  const initialValues = {
    sunModeActive: model?.sunModeActive ?? false,
    numberPhases: model?.numberPhases ?? 1,
    maxChargeCurrent: model?.maxChargeCurrent ?? 0,
    minChargeCurrent: model?.minChargeCurrent ?? 0,
    upperCurrentLimit: model?.upperCurrentLimit ?? 0,
    chargeStopHysteresis: model?.chargeStopHysteresis ?? 0,
  }

  const validationSchema = object().shape({
    sunModeActive: validationFields.sunModeActiveField(),
    numberPhases: validationFields.numberPhasesField(ALLOWED_NUMBER_PHASES),
    maxChargeCurrent: validationFields.maxChargeCurrentField(),
    upperCurrentLimit: validationFields.upperCurrentLimitField(),
    minChargeCurrent: validationFields.minChargeCurrentField(),
    chargeStopHysteresis: validationFields.chargeStopHysteresisField(),
  })
  return { initialValues, validationSchema }
}
